export const LEARN_DASHBOARD_PAGE_NAME = 'Learn Dashboard';
export const LEARN_DASHBOARD_PAGE_KEY = 'homepage';

export const APP_ID = 'mevliu65';
export const APP_ID_QA = 'if08s3kq';
